/* @flow */
import { sortBy, clone } from 'lodash';
import Collection from 'lib/Collection';
import apiRequest from 'lib/apiRequest';
import Message from 'entities/Message';
import jstz from 'jstimezonedetect';

class Messages extends Collection<Message> {
  initialize() {
    this.model = Message;
  }

  comparator(a: Message, b: Message): number {
    // $FlowFixMe these can be undefined, resulting in NaN for return value
    return b.getSeq() - a.getSeq();
  }

  getReverseArray() {
    const modelsCopy: any[] = clone(this.models);
    return sortBy<any>(modelsCopy, message => message.getSeq());
  }

  // XXX (rgoldfinger) remove when cleaning up old way of sending messages
  static yieldMessagesForGroupId(groupId: Backbone$Id, options: Object = {}) {
    return apiRequest(`/classes/${groupId}/messages`, 'GET', options).then(_handleMessageResponse);
  }

  static yieldThreadMessagesForGroupId(
    groupId: Backbone$Id,
    threadUuid: string,
    options: Object = {}
  ) {
    return apiRequest(`/classes/${groupId}/threads/${threadUuid}/messages`, 'GET', options).then(
      _handleMessageResponse
    );
  }

  static yieldScheduledThreadMessagesForGroupId(
    groupId: Backbone$Id,
    threadUuid: string,
    options: Object = {}
  ) {
    return apiRequest(
      `/classes/${groupId}/threads/${threadUuid}/messages/scheduled`,
      'GET',
      options
    ).then(_handleMessageResponse);
  }

  // DELETEME not used
  // $FlowFixMe missing annotation
  static export(groupIds, since, until) {
    const tz = jstz.determine();
    const timezone = tz.name();

    return apiRequest('/messages/export', 'POST', {
      group_ids: groupIds,
      since,
      until,
      time_zone: timezone,
    });
  }
}

function _handleMessageResponse(response) {
  const messages = new Messages();
  if (response.messages) {
    response.messages.forEach(messageJSON => {
      messages.add(Message.fromJSON(messageJSON));
    });
  }
  return messages;
}

export default Messages;
